import { isArrayValid } from "../helpers/utility";
import BaseService from "./BaseService";

export default class DirectorShipService extends BaseService {
  async fetch(): Promise<string[]> {
    try {
      const APIResponse = await new BaseService(true).get<string[]>(
        "/core/InstallationGroup/GetDirectorShipList"
      );

      if (isArrayValid(APIResponse)) {
        return APIResponse.filter((x) => x);
      }

      return new Promise((_, rej) => rej(`Invalid response → ${APIResponse}`));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("DirectorShipService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async fetchDistinct() {
    try {
      return await new BaseService(true).get("Customer/ListarDiretoriasDistintas");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("DirectorShipService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }
}
